import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'calcSvgYPosition',
    standalone: false
})
export class CalcSvgYPositionPipe implements PipeTransform {
  transform(
    y: number,
    flip: boolean,
    { width, height }: { width: number; height: number },
    circle = false
  ): unknown {
    if (y < 0) {
      return (
        1250 -
        ((circle ? 0 : 1) * (flip ? width : height)) / 2 +
        1250 * (-y / 125)
      );
    }
    return (
      1250 * (1 - y / 125) - ((circle ? 0 : 1) * (flip ? width : height)) / 2
    );
  }
}
